<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>系统管理</el-breadcrumb-item>
        <el-breadcrumb-item>角色管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="searchForm" :model="listParams" inline>
        <el-form-item label="角色名称：" prop="roleName">
          <el-input clearable v-model="listParams.roleName" placeholder="请输入角色名称" />
        </el-form-item>
        <el-form-item label=" ">
          <el-button @click="loadTableData()" size="small" type="primary">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
      <div slot="action"></div>

      <hx-table-result-col>
        <div class="wrap-table-info-display">
          <section>
            <el-button type="primary" size="small" @click="handleAdd">新增</el-button>
          </section>
          <span class="table-info-display">
            <span>总条数：</span>
            <span class="alert-text ft16">{{ pager.total }}</span>
          </span>
        </div>
      </hx-table-result-col>

      <el-table slot="content" :data="dataList" border>
        <el-table-column type="selection" width="55"></el-table-column>

        <el-table-column align="center" label="序号" width="60">
          <template slot-scope="scope">
            <span>{{ (pager.pageIndex - 1) * pager.pageSize + scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column align="center" label="角色名称" prop="roleName"></el-table-column>

        <el-table-column align="center" label="备注" prop="remark"></el-table-column>

        <el-table-column align="center" label="创建时间" prop="createdTime"></el-table-column>

        <el-table-column align="center" label="操作" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" class="color-success" @click="handleAssignAuth(scope.row.id)">分配权限</el-button>
            <el-button type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
            <confirm-button type="text" style="margin: 0 10px" title="确认要删除该角色？" @confirmed="handleDelete(scope.row.id)">
              <span class="color-danger">删除</span>
            </confirm-button>
          </template>
        </el-table-column>
      </el-table>
    </hx-table-result>

    <RoleDialog :dialogVisible.sync="roleDialogVisible" :id="roleId" @onSuccess="loadTableData()" />

    <AssignAuthDialog :dialogVisible.sync="assignAuthDialogVisible" :id="roleId" />
  </div>
</template>

<script>
import RoleDialog from "../components/RoleDialog";
import AssignAuthDialog from "../components/AssignAuthDialog";
export default {
  components: {
    RoleDialog,
    AssignAuthDialog,
  },
  data() {
    return {
      tableLoading: false,
      listParams: {
        roleName: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      dataList: [],
      roleDialogVisible: false,
      roleId: "",
      assignAuthDialogVisible: false,
    };
  },
  mounted() {
    this.loadTableData();
  },
  methods: {
    /**
     * 加载列表数据
     */
    loadTableData() {
      this.tableLoading = true;
      this.$http({
        url: global.apiUrl + "/role/roleList",
        method: "GET",
        params: {
          supplyId: this.supplyId,
          pageIndex: this.pager.pageIndex,
          pageSize: this.pager.pageSize,
        },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            if (res.body.data) {
              this.dataList = res.body.data.data;
              this.pager.total = res.body.data.total;
            } else {
              this.dataList = [];
            }
            this.tableLoading = false;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;

          console.error(err);
        });
    },
    handleAssignAuth(id) {
      this.assignAuthDialogVisible = true;
      this.roleId = id;
    },
    handleAdd() {
      this.roleDialogVisible = true;
      this.roleId = "";
    },
    handleEdit(id) {
      this.roleDialogVisible = true;
      this.roleId = id;
    },
    handleDelete(id) {
      this.$http({
        url: global.apiUrl + `/role/deleteRole/${id}`,
        method: "DELETE",
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
  },
};
</script>
<style lang="less" scoped>
.home-container {
  .alert-text {
    color: #e9a021;
    cursor: default;
  }
}
</style>
